var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsSidebarLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_2220_801)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.5625 5.22205C16.8489 5.38494 17.0867 5.6212 17.2515 5.90652C17.4163 6.19184 17.5021 6.51591 17.5 6.84539V12.9154C17.5 13.5896 17.1308 14.2112 16.535 14.5387L10.91 18.0971C10.6311 18.2502 10.3181 18.3304 10 18.3304C9.68186 18.3304 9.36887 18.2502 9.09 18.0971L3.465 14.5387C3.17347 14.3794 2.9301 14.1447 2.76034 13.8591C2.59058 13.5735 2.50067 13.2476 2.5 12.9154V6.84455C2.5 6.17039 2.86917 5.54955 3.465 5.22205L9.09 1.90539C9.37711 1.74708 9.69964 1.66406 10.0275 1.66406C10.3554 1.66406 10.6779 1.74708 10.965 1.90539L16.59 5.22205H16.5625Z",
    stroke: "#F89608",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.5 10C7.5 10.663 7.76339 11.2989 8.23223 11.7678C8.70107 12.2366 9.33696 12.5 10 12.5C10.663 12.5 11.2989 12.2366 11.7678 11.7678C12.2366 11.2989 12.5 10.663 12.5 10C12.5 9.33696 12.2366 8.70107 11.7678 8.23223C11.2989 7.76339 10.663 7.5 10 7.5C9.33696 7.5 8.70107 7.76339 8.23223 8.23223C7.76339 8.70107 7.5 9.33696 7.5 10Z",
    stroke: "#F89608",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2220_801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsSidebarLogo);
export default __webpack_public_path__ + "static/media/settingsSidebarLogo.1e2361242f5cde8104e8a95446d42a2b.svg";
export { ForwardRef as ReactComponent };